<template>
    <div>
        <KeepAlive>
            <component v-if="VenueSelectComponent" :is="VenueSelectComponent"></component>
        </KeepAlive>
    </div>
</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';
    import { VueFlip } from 'vue-flip';
    import VenueSelectRON from '@components/checkout/VenueSelectRON.vue';
    import VenueSelectFieldNotary from '@components/checkout/VenueSelectFieldNotary.vue';
    import VenueSelectCourier from '@components/checkout/VenueSelectCourier.vue';
    import VenueSelectFieldInspection from '@components/checkout/VenueSelectFieldInspection.vue';
    import VenueSelectApostille from '@components/checkout/VenueSelectApostille.vue';
    
    import { useEditorStore } from '/src/stores/EditorStore';

    export default {
        inheritAttrs: false,
        name: 'CheckoutVenueSelect',
        mixins: [],
        props: ['modelValue', 'ronconfig','fieldnotaryconfig','apostilleconfig','fieldinspectionconfig'],
        emits: ['update:modelValue'],
        components: {
            VenueSelectRON,
            VenueSelectFieldNotary,
            VenueSelectCourier,
            VenueSelectFieldInspection,
            VenueSelectApostille,
            VueFlip
        },
        computed:
        {
            VenueSelectComponent: function () {
                switch (this.Store.Checkout.Cart.SelectedService) {
                    case 'RONNotarization':
                        return VenueSelectRON;
                        break;
                    case 'FieldNotarization':
                        return VenueSelectFieldNotary;
                        break;
                    case 'CourierDelivery':
                        return VenueSelectCourier;
                        break;
                    case 'FieldInspection':
                        return VenueSelectFieldInspection;
                        break;
                    case 'Apostille':
                        return VenueSelectApostille;
                        break;                   
                }   

                return null;
            }
        },
        watch: {            
        },
        data() {
            return {
                Store: {},
            };
        },
        methods:
        {                      
        },
        created() {
            this.Store = useEditorStore();
        },
        beforeUnmount() {
        },
        mounted() {   
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .dots-fill {
        overflow: hidden;
        white-space: nowrap;
    }

        .dots-fill .dots-after:after {
            content: " ....................................................................................................................................................................";
        }

    .highlight-hover:hover{
        background-color : #e4ffd9
    }

    .flip-enter-active {
        transition: all 0.4s ease;
    }

    .flip-leave-active {
        display: none;
    }

    .flip-enter, .flip-leave {
        transform: rotateY(180deg);
        opacity: 0;
    }

    .light-info {
        color:rgba(10, 191, 83, 0.5) !important;
    }
    .numberCircle {
        position: relative;
        top: -8px;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        padding: 4px;
        padding-top: 8px;
        background: rgba(10, 191, 83, 0.5);
        border: 2px solid limegreen;
        color: white;
        text-align: center;
        font: 14px Arial, sans-serif;
    }

    .checkout-content {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        z-index: 1;
    }

        .checkout-content::before {
            content: "";
            display: block;
            position: absolute;
            z-index: -1;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(255,255,255,.8);
        }

        /* Style the content inside .contact-checkout-content */
        .checkout-content .row {
            color: #fff;
        }
</style>

